import { ErrorAlert } from "./ErrorAlert";

/** Состояние загрузки/ошибки страницы целиком. */
export function PageState({ loading, error }: { loading: boolean; error: string | null }) {
  if (loading) return <div className="p-5 text-fg-faint">загружаю…</div>;
  return (
    <div className="p-5">
      <ErrorAlert text={error ?? "нет данных"} />
    </div>
  );
}
